import { render, staticRenderFns } from "./loading-spinner.vue?vue&type=template&id=50f98688&"
import script from "./loading-spinner.vue?vue&type=script&lang=js&"
export * from "./loading-spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports